var ref=document.referrer;
console.log(ref);

if (ref.includes("alpacamall")) {
   document.getElementById('popup-wrap').style.display = 'block';
  document.getElementById("btn-close").addEventListener("click", function(event) {
    document.getElementById('popup-wrap').style.display = 'none';
  });
	console.log("Sí")
} else {
	console.log("No")
}

if (ref.includes("panamahatmall")) {
   document.getElementById('popup-wrap2').style.display = 'block';
  document.getElementById("btn-close2").addEventListener("click", function(event) {
    document.getElementById('popup-wrap2').style.display = 'none';
  });
	console.log("Sí")
} else {
	console.log("No")
}

/*if(ref == 'https://www.alpacamall.com/' ){
  console.log('layer mostrar');
 
}*/


if ((ref.indexOf(window.location.href) > -1) !== true) { // If referral is same page then page will not redirect.
    
}


var website = getParameterByName('website');

if(website == 'alm'){
  document.getElementById('popup-wrap').style.display = 'block';
  document.getElementById("btn-close").addEventListener("click", function(event) {
    document.getElementById('popup-wrap').style.display = 'none';
  });
  /*document.getElementById('popup-wrap').style.display = 'block';
  setTimeout(function () {
    document.getElementById('popup-wrap').style.display = 'none';
  }, 2000);*/
}

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}